import React from 'react';
import { Login } from 'react-admin';

const LoginPage = () => (
  <Login backgroundImage="https://906370.smushcdn.com/2184058/wp-content/themes/Archive-1/images/splash/homepage/desktop/headerimage_desktop_x2.jpg" />
);

export default React.memo(LoginPage);
